<!-- dialog.vue -->
<template>
	<div class="dialog-overlay" @click="close" v-if="visible">
		<div class="dialog-content flex-center" @click.stop>
			<div class="mr-12">{{ message }}</div>
			<dot />
		</div>
	</div>
</template>

<script>
import Dot from './dot.vue';
export default {
	props: {
		message: {
			type: String,
			default: 'Loading...',
		},
	},
	data() {
		return {
			visible: false,
		};
	},
	components: { Dot },
	methods: {
		show() {
			this.visible = true;
		},
		pureClose() {
			this.visible = false;
		},
		close() {
			this.visible = false;
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
.dialog-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.dialog-content {
	background: white;
	padding: 20px;
	border-radius: 8px;
	width: 400px;
}
</style>
